import { connect } from 'react-redux';

import { authenticationActions } from 'dataflow/distributorPortal/actions';

import LoginPresentation from './LoginPresentation';

function mapStateToProps(state) {
    const { 
        login_requesting, login_status, isLoggedIn, login_errorMsg, 
        getUserInfo_requesting, userInfo,
        
        generateEmailOTP_requesting, generateEmailOTP_status,
        generateEmailOTP_errorMsg,
    } = state.distributorPortal_authenticationReducers;

	return {
        login_requesting,
        login_status,
        isLoggedIn,
        login_errorMsg,

        getUserInfo_requesting,
        userInfo,

        generateEmailOTP_requesting, generateEmailOTP_status,
        generateEmailOTP_errorMsg,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        login: (loginInfoObj) => { dispatch(authenticationActions.login(loginInfoObj)); },
        getUserInfo: () => { dispatch(authenticationActions.getUserInfo()); },
        generateEmailOTP: (email) => { dispatch(authenticationActions.generateEmailOTP(email)); }
    };
}

const Login = connect(mapStateToProps, mapDispatchToProps)(LoginPresentation);

export default Login;